module.exports = __webpack_public_path__ + "img/legal-expenses.b200293f.png";